export default "__VITE_ASSET__297ca526__"